export default class State {
    // Default state values
    static isRunning = false;
    static loadSetup = "treble"
    static isLoaded = true
    static keySignature = "C"
    static keyMode = "Major"
    static reset = false
}